import ProdutoTributacaoAtualizacaoService from "@/services/ProdutoTributacaoAtualizacaoService";

export const produtoTributacaoAtualizacao = {
  namespaced: true,
  state: {
    produtoTributacaoAtualizacao: {},
  },
  actions: {
    getCampos({ commit }) {
      return ProdutoTributacaoAtualizacaoService.GetCampos().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    exportar({ commit }, payload) {
      return ProdutoTributacaoAtualizacaoService.Exportar(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    validar({ commit }, payload) {
      return ProdutoTributacaoAtualizacaoService.Validar(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    aplicar({ commit }, payload) {
      return ProdutoTributacaoAtualizacaoService.Aplicar(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default produtoTributacaoAtualizacao;
